import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import localStorage from 'local-storage';
import { withTranslation } from 'react-i18next';

import '../css/BalanceByAccount.css';

class PeriodComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            period: "3",
            startDate: moment((moment().subtract(3, 'months'))).add(1, 'day'),
            endDate: moment(),
            usrMemberSetId: null,
            accountBalances: [],
            fundBalances: []
        }

        this.getAccountBalances = this.getAccountBalances.bind(this);
        this.getFundBalances = this.getFundBalances.bind(this);
        // this.getAccountReturns = this.getAccountReturns.bind(this);
        // this.getFundReturns = this.getFundReturns.bind(this);
        this.handlePeriod = this.handlePeriod.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        const usrMemberSetId = props.member.usrMemberSetId;
        return {
            usrMemberSetId: usrMemberSetId
        }
    }

    componentDidMount() {
        this.setState({
            period: !localStorage.get("period") ? this.state.period : localStorage.get("period"),
            startDate: !localStorage.get("startDate") ? this.state.startDate : localStorage.get("startDate"),
            endDate: !localStorage.get("endDate") ? this.state.endDate : localStorage.get("endDate")
        });
        this.getAccountBalances(null,this.state);
        // this.getAccountReturns(this.state);
        this.getFundBalances(null,this.state);
        // this.getFundReturns(this.state);
    }

    componentDidUpdate(prevProps, prevState) {
        localStorage.set("startDate", this.state.startDate)
        localStorage.set("endDate", this.state.endDate)
        if (prevState.startDate !== this.state.startDate || prevState.endDate !== this.state.endDate
            || prevProps.accounts !== this.props.accounts || prevProps.funds !== this.props.funds) {
            document.getElementById("refreshStatus").value="Refreshing..."
            this.getAccountBalances(null,this.state, prevProps)
            // this.getAccountReturns(this.state, prevProps);
            this.getFundBalances(null,this.state, prevProps)
            // this.getFundReturns(this.state, prevProps);

        }
    }

    componentWillUnmount() {
        localStorage.clear("period");
    }

    getAccountBalances(event,state, prevProps) {

        // console.log(moment(this.state.endDate))
        // console.log(moment(this.state.endDate) instanceof Date)
        // console.log("1")
        // console.log(state.endDate)
        // console.log(state.endDate instanceof Date)

        // console.log(this.state)

        this.props.startLoadingAccountBalances(state.usrMemberSetId,
            moment(this.state.startDate).format('YYYY-MM-DD'),
            moment(this.state.endDate).format('YYYY-MM-DD'))
        
        this.props.startLoadingAccountReturns(state.usrMemberSetId,
            moment(this.state.startDate).format('YYYY-MM-DD'),
            moment(state.endDate).format('YYYY-MM-DD'),
            this.props.accounts)

    }

    getFundBalances(event,state, prevProps) {
        this.props.startLoadingFundBalances(state.usrMemberSetId,
            moment(state.startDate).format('YYYY-MM-DD'),
            moment(state.endDate).format('YYYY-MM-DD'),
            this.props.accounts, this.props.funds)
        
        this.props.startLoadingFundReturns(state.usrMemberSetId,
            moment(state.startDate).format('YYYY-MM-DD'),
            moment(state.endDate).format('YYYY-MM-DD'),
            this.props.accounts, this.props.funds)
        
        if(document.getElementById("refreshStatus").value === "Refreshing..."){
            document.getElementById("refreshStatus").value = "Refreshed"
        }

        console.log(document.getElementById("refreshStatus").value)
    }

    // getAccountReturns(state, prevProps){
    //     this.props.startLoadingAccountReturns(state.usrMemberSetId,
    //         moment(state.startDate).format('YYYY-MM-DD'), 
    //         moment(state.endDate).format('YYYY-MM-DD'), 
    //         this.props.accounts).then(() => this.setState({loading: false}))
    // }

    // getFundReturns(state, prevProps){
    //     this.props.startLoadingFundReturns(state.usrMemberSetId,
    //         moment(state.startDate).format('YYYY-MM-DD'), 
    //         moment(state.endDate).format('YYYY-MM-DD'), 
    //         this.props.accounts).then(() => this.setState({loading: false}))
    // }

    handlePeriod(e) {
        localStorage.set("period", e.target.value);
        if (e.target.value === "0") {
            this.setState({
                period: e.target.value,
                startDate: moment().format("YYYY-MM-DD"),
                endDate: moment().add(1, 'month').format("YYYY-MM-DD")
            })
        }
        else if (e.target.value === "1" || e.target.value === "3" || e.target.value === "12") {
            this.setState({
                period: e.target.value,
                startDate: moment().subtract(Number(e.target.value), 'months').format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD")
            })
        }
    }

    handleDates(date, id) {
        this.setState({ period: "-1" })
        if (id === "start")
            this.setState({
                startDate: date,
                period: "-1"
            })
        else if (id === "end") {
            this.setState({
                endDate: date,
                period: "-1"
            })
        }
    }

    handleClick = (event) => {
        // Call both functions with the current state
        this.getAccountBalances(event, this.state);
        this.getFundBalances(event, this.state);
    };

    render() {
        const { t } = this.props
        
        return (
            <div className="balanceByAccount period">
                <div>
                    <div style={{ display: "inline-block", fontSize: "14.6667px", fontFamily: "Roboto, sans-serif", color: "#333333" }}>{t('balanceByAccount:period')}</div>
                    <div className="radioButton"><input type="radio" id="0" name="period" value="0" checked={this.state.period === "0"}
                        onChange={(e) => this.handlePeriod(e)} /></div>
                    <div className="radioButtonText">{t('balanceByAccount:currentMonth')}</div>
                    <div className="radioButton"><input type="radio" id="1" name="period" value="1" checked={this.state.period === "1"}
                        onChange={(e) => this.handlePeriod(e)} /></div>
                    <div className="radioButtonText">{t('balanceByAccount:lastMonth')}</div>
                    <div className="radioButton"><input type="radio" id="3" name="period" value="3" checked={this.state.period === "3"}
                        onChange={(e) => this.handlePeriod(e)} /></div>
                    <div className="radioButtonText">{t('balanceByAccount:threeMonths')}</div>
                    <div className="radioButton"><input type="radio" id="12" name="period" value="12" checked={this.state.period === "12"}
                        onChange={(e) => this.handlePeriod(e)} /></div>
                    <div className="radioButtonText">{t('balanceByAccount:twelveMonths')}</div>
                    <div className="radioButton"><input type="radio" id="-1" name="period" value="-1" checked={this.state.period === "-1"}
                        onChange={(e) => this.handlePeriod(e)} /></div>
                    <div className="radioButtonText">{t('balanceByAccount:chosen')}</div>
                </div>
                <table className="date">
                    <tbody>
                        <tr>
                            <td>{t('memberDetails:openingAt')}
                                <div style={{ paddingLeft: "5px", display: "inline" }}>
                                    <DatePicker
                                        id="start"
                                        dateFormat="dd/MM/yyyy"
                                        onInputClick={() => this.handleDates()}
                                        selected={new Date(this.state.startDate)}
                                        onChange={(date) => this.handleDates(date, "start")}
                                    />
                                </div>
                            </td>
                            <td>{t('memberDetails:closingAt')}
                                <div style={{ paddingLeft: "5px", display: "inline" }}>
                                    <DatePicker id="end"
                                        dateFormat="dd/MM/yyyy"
                                        onInputClick={() => this.handleDates()}
                                        selected={new Date(this.state.endDate)}
                                        onChange={(date) => this.handleDates(date, "end")}
                                    />
                                </div>
                            </td>
                            {/* <td><p id="refreshStatus"></p></td> */}
                            {this.props.isAccountBalancesEmpty ? <></>:<td><button  id="refreshStatus" className="refresh">{t('adviserHomePage:refresh')}</button></td>}
                            </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}

export default withTranslation()(PeriodComponent);